import axios from "axios";
import { APIURL } from "../../../../APIHandler/APIURL"
import { Headers } from "../../../../APIHandler/HeaderAPI";
import { reloadHandler } from "../../../../utlis/utlis";
import { Admin_Event_List_failure, Admin_Event_List_request, Admin_Event_List_success } from "../../../Reducer/Admin/EventList/EventListSlice";

export const AdminEventListAPI = (payload) => async (dispatch, getState) => {
    // const eventItemId=localStorage.getItem("eventItemId")
    const auth_token = localStorage.getItem("auth_token")
    dispatch(Admin_Event_List_request())
    try {
        const { data } = await axios.get(`${APIURL.admineventlist}`,{
            headers: {
                "host-url": Headers?.["host-url"],
               "event-slug":Headers?.["event-slug"],
                "language": Headers?.language,
                "Content-type": "application/json",
                Authorization: `Bearer ${auth_token}`
            },
        })
        dispatch(Admin_Event_List_success(data))
    } catch (error) {
        reloadHandler(error?.response?.status)
        dispatch(Admin_Event_List_failure(error?.response?.status))
    }
}


  